import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/codice.css';
import App from './App';
import { register as registerServiceWorker } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// PWA: make the app installable + offline-capable (production only).
registerServiceWorker();